<template lang="pug">
  div
    form.w-full.max-w-3xl.mt-6(v-on:submit="startSending")
      .flex.flex-wrap.-mx-3
        .w-full.px-3(class='md:w-2/4 md:mb-0')
          label(for='address') Address
          input#address(placeholder='0.0.0.0' type="text" v-model="address" v-bind:disabled="sending")
          p.text-gray-600.text-xs.italic Both IPv4 and IPv6 addresses are supported.
        .w-full.px-3(class='md:w-1/4 md:mb-0')
          label(for='ttl') TTL
          input#ttl(placeholder='200' type="text" v-model="ttl" v-bind:disabled="sending")
        .w-full.px-3(class='md:w-1/4 md:mb-0')
          label(for='timeout') Timeout
          input#timeout(placeholder='1000' type="text" v-model="timeout" v-bind:disabled="sending")
      input.button.mt-3(type="submit" v-bind:disabled="loading" v-bind:class="{ 'opacity-50': loading }" value="Send")
      button(class="button bg-red-600 hover:bg-red-400 ml-4 mt-3" v-if="sending" v-on:click="stopSending") Cancel
    div.text-gray-100.font-mono.bg-black.rounded.p-4.mt-6(v-if="hasError || responses && responses.length > 0")
      div.text-red-400(v-if="hasError") {{errorMessage}}
      div(v-else v-for="response in responses")
        div(v-if="response.type === 'destination_unreachable'") Destination unreachable error received from {{response.source}}
        div(v-else-if="response.type === 'ttl_expired'") TTL expired error received from {{response.source}}
        div(v-else-if="response.type === 'success'") Response from {{response.source}} in {{(response.time * 1000.0).toFixed(2)}} ms
        div(v-else-if="response.type === 'no_reply'") No response
        div(v-else) Unknown error
</template>
<script>
import common_computed from "@/mixins/common_computed";
import errors from "@/mixins/errors";

export default {
  mixins: [common_computed, errors],
  data() {
    return {
      address: "",
      ttl: null,
      timeout: null,
      sending: false,
      sendTimeoutID: null,
      timeoutID: null,
      responses: [],
    };
  },
  computed: {
    ipType() {
      if (this.address.match(/^(?:[0-9]{1,3}\.){3}[0-9]{1,3}$/)) {
        return "ipv4";
      } else {
        return "ipv6";
      }
    },
    echoBody() {
      let body = {
        requests: [
          {
            host: this.address,
          },
        ],
      };
      if (this.ttl) {
        body.requests[0].ttl = this.ttl;
      }
      if (this.timeout) {
        body.options = {
          timeout: this.timeout,
        };
      }

      return body;
    },
  },
  beforeDestroy() {
    if (this.sending || this.loading) {
      this.stopSending();
    }
  },
  methods: {
    startSending(e) {
      e.preventDefault();
      if (this.sending) {
        this.stopSending();
      }

      this.responses = [];
      this.clearError();

      this.sending = true;
      this.loading = true;

      this.timeoutID = setTimeout(this.stopSending, 30000);

      this.sendEcho();
    },
    stopSending() {
      this.loading = false;
      this.sending = false;
      if (this.timeoutID) {
        clearTimeout(this.timeoutID);
        this.timeoutID = null;
      }
      if (this.sendTimeoutID) {
        clearTimeout(this.sendTimeoutID);
        this.sendTimeoutID = null;
      }
    },
    sendEcho() {
      fetch(`${this.selectedHost}/v1/icmp/${this.ipType}`, {
        method: "POST",
        body: JSON.stringify(this.echoBody),
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((resp) => {
          if (!resp.ok) {
            this.hasError = true;
          }
          return resp.json();
        })
        .then((json) => {
          if (this.hasError) {
            this.stopSending();
            this.setError(json.error.description);
            return;
          } else if (json.responses[0]) {
            this.responses.push(json.responses[0]);
          } else if (json.responses.length && json.responses[0] === null) {
            this.responses.push({ type: "no_reply" });
          }
          this.queueNextEcho();
        })
        .catch((error) => {
          console.error(error);
          this.setError("Unable to perform echo, an error occurred");
        });
    },
    queueNextEcho() {
      if (!this.sending) {
        return;
      }

      this.sendTimeoutID = setTimeout(this.sendEcho, 1000);
    },
  },
};
</script>
